/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2024-10-29 17:13:41
 */
import { RouteRecordRaw } from 'vue-router'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'
const DataDashboard = () => import('@/views/dataDashboard/Index.vue')
const ExpressTracking = () => import('@/views/expressTracking/Index.vue')
const OrderEntry = () => import('@/views/orderEntry/Index.vue')
const ClientManagement = () => import('@/views/clientManagement/Index.vue')
const HandoverList = () => import('@/views/handover/Index.vue')
const HandoverDetail = () => import('@/views/handoverDetail/Index.vue')
const SendWarehouse = () => import('@/views/sendWarehouse/Index.vue')
const OrderList = () => import('@/views/orderList/Index.vue')
const UpdatePwd = () => import('@/views/updatePwd/Index.vue')
const PrintSetting = () => import('@/views/printSetting/Index.vue')
const SendSetting = () => import('@/views/sendSetting/Index.vue')
const DispatchList = () => import('@/views/dispatchList/Index.vue')
const SendRecord = () => import('@/views/sendRecord/Index.vue')
const StaffDispatchList = () => import('@/views/staffDispatchList/Index.vue')
const SystemSwitch = () => import('@/views/systemSwitch/Index.vue')
/** 数据看板 */
const dataCenter: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.DATADASHBOARD],
    name: 'DataDashboard',
    component: DataDashboard,
    meta: { title: NameEnum[UnionEnum.DATADASHBOARD], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/picturePassRate',
    name: 'PicturePassRate',
    component: () => import('@/views/picturePassRate/Index.vue'),
    meta: { title: '签收图片合格率报表', requiresAuth: true, keepAlive: true }
  }
]

/** 数据/报表中心 */
const dataReportCenter: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.STAFFDISPATCHLIST],
    name: 'StaffDispatchList',
    component: StaffDispatchList,
    meta: { title: NameEnum[UnionEnum.STAFFDISPATCHLIST], requiresAuth: true, keepAlive: true }
  }
]

/** 快件管理 */
const expressManagement: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.EXPRESSTRACKING],
    name: 'ExpressTracking',
    component: ExpressTracking,
    meta: { title: NameEnum[UnionEnum.EXPRESSTRACKING], requiresAuth: true, keepAlive: true }
  }
]

/** 订单管理 */
const orderManagement: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.ORDERENTRY],
    name: 'OrderEntry',
    component: OrderEntry,
    meta: { title: NameEnum[UnionEnum.ORDERENTRY], requiresAuth: true, keepAlive: true }
  }
]

/** 客户管理 */
const clientManagement: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.CLIENTMANAGEMENT],
    name: 'ClientManagement',
    component: ClientManagement,
    meta: { title: NameEnum[UnionEnum.CLIENTMANAGEMENT], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.DISPATCHLIST],
    name: 'DispatchList',
    component: DispatchList,
    meta: { title: NameEnum[UnionEnum.DISPATCHLIST], requiresAuth: true, keepAlive: true }
  }
]

/** 交接管理 */
const handoverManagement: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.HANDOVERLIST],
    name: 'HandoverList',
    component: HandoverList,
    meta: { title: NameEnum[UnionEnum.HANDOVERLIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.HANDOVERDETAIL],
    name: 'HandoverDetail',
    component: HandoverDetail,
    meta: { title: NameEnum[UnionEnum.HANDOVERDETAIL], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.SENDRECORD],
    name: 'SendRecord',
    component: SendRecord,
    meta: { title: NameEnum[UnionEnum.SENDRECORD], requiresAuth: true, keepAlive: true }
  }
]

/** 订单管理 */
const orderList: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.ORDERLIST],
    name: 'OrderList',
    component: OrderList,
    meta: { title: NameEnum[UnionEnum.ORDERLIST], requiresAuth: true, keepAlive: true }
  }
]

/** 寄件入库管理 */
const warehouseManagement: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.SENDWAREHOUSE],
    name: 'SendWarehouse',
    component: SendWarehouse,
    meta: { title: NameEnum[UnionEnum.SENDWAREHOUSE], requiresAuth: true, keepAlive: true }
  }
]
/** 退件查询 */
const returnWarehouse: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.RETURNWAREHOUSE],
    name: 'ReturnWarehouse',
    component: () => import('@/views/returnWarehouse/Index.vue'),
    meta: { title: NameEnum[UnionEnum.RETURNWAREHOUSE], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.RETURNWAREHOUSEENTRY],
    name: 'ReturnWarehouseEntry',
    component: () => import('@/views/returnWarehouse/Entry.vue'),
    meta: { title: NameEnum[UnionEnum.RETURNWAREHOUSEENTRY], requiresAuth: true, keepAlive: true }
  }
]

/** 系统切换 */
const systemSwitch: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.SYSTEMSWITCH],
    name: 'SystemSwitch',
    component: SystemSwitch,
    meta: {
      title: NameEnum[UnionEnum.SYSTEMSWITCH],
      requiresAuth: true,
      keepAlive: true,
      requiresSwitching: true
    }
  }
]

/** 基础设置 */
const setting: RouteRecordRaw[] = [
  /** 修改密码 */
  {
    path: UrlEnum[UnionEnum.UPDATEPWD],
    name: 'UpdatePwd',
    component: UpdatePwd,
    meta: { title: NameEnum[UnionEnum.UPDATEPWD], requiresAuth: true, keepAlive: true }
  },
  /** 打印设置 */
  {
    path: UrlEnum[UnionEnum.PRINTSETTING],
    name: 'PrintSetting',
    component: PrintSetting,
    meta: { title: NameEnum[UnionEnum.PRINTSETTING], requiresAuth: true, keepAlive: true }
  },
  /** 寄件设置 */
  {
    path: UrlEnum[UnionEnum.SENDSETTING],
    name: 'SendSetting',
    component: SendSetting,
    meta: { title: NameEnum[UnionEnum.SENDSETTING], requiresAuth: true, keepAlive: true }
  }
]

export {
  dataCenter,
  dataReportCenter,
  expressManagement,
  orderManagement,
  clientManagement,
  handoverManagement,
  orderList,
  warehouseManagement,
  setting,
  returnWarehouse,
  systemSwitch
}
